export default {
  GET_AREAS_REQUEST: 'GET_AREAS_REQUEST',
  GET_AREAS_SUCCESS: 'GET_AREAS_SUCCESS',
  GET_AREAS_FAILURE: 'GET_AREAS_FAILURE'
};
